var map = {
	"./partner1.png": "c572",
	"./partner10.png": "bd36",
	"./partner11.png": "fda9",
	"./partner12.png": "3e99",
	"./partner13.png": "bf02",
	"./partner14.png": "6379",
	"./partner15.png": "d024",
	"./partner16.png": "69dd",
	"./partner17.png": "41fa",
	"./partner18.png": "2a7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f04";